import { combineReducers } from 'redux';
import runtime from './runtime';
// import { reducer } from 'RequestFlight';

export default combineReducers({
  runtime,
  // reqflight: reducer
});
